import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class FileUploadApiService {
    constructor(private apiService: ApiService) { }

    fileUpload(files, appId, fileUploadType, isNewRecord, id) {
        var IsNewRecordData = 0;
        if(isNewRecord == true || isNewRecord == 1){
            IsNewRecordData = 1;
        }
        return this.apiService.fileUpload('/fileupload/' + appId + '/appid/' + fileUploadType + '/fileuploadtype/' + IsNewRecordData + '/isNewRecord/' + id, files).map(data => data);
    }

    userDataImport(file) {
        return this.apiService.fileUpload('/userdataupload', file).map(data => data);
    }

    userProfileImageUpload(file, appId) {
        return this.apiService.fileUpload('/userprofileimageupload/' + appId, file).map(data => data);
    }
    
    unitDataImport(file) {
        return this.apiService.fileUpload('/unitdataupload', file).map(data => data);
    }

    fileVideoThumbImageUpload(files, appId, fileUploadType, isNewRecord, id) {
        var IsNewRecordData = 0;
        if(isNewRecord == true || isNewRecord == 1){
            IsNewRecordData = 1;
        }
        return this.apiService.fileUpload('/videothumbimagefileupload/' + appId + '/appid/' + fileUploadType + '/fileuploadtype/' + IsNewRecordData + '/isNewRecord/' + id, files).map(data => data);
    }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/common/file-upload-management.ts